"use client";

import Section from "../components/Section";
import { Box, Pagination, SearchBox, Tab, TabList, Tabs } from "@repo/ui";
import Webinars from "../components/webinar/Webinars";
import { TimeLineView } from "@/graphql/queries/event-query";
import { Suspense, useCallback, useState } from "react";
import WebinarsLoader from "@/components/loaders/WebinarsLoader";

type PageInfoType = {
  perPage: number;
  total: number;
  currentPage: number;
};

const UpcomingAndCompletedWebinars = () => {
  const [pageInfo, setPageInfo] = useState<PageInfoType>({
    perPage: 9,
    total: 0,
    currentPage: 1,
  });

  const [timeLineView, setTimeLineView] = useState(TimeLineView.UPCOMING);
  const [page, setPage] = useState(1);

  const handleTabChange = (value: TimeLineView) => {
    setTimeLineView(value);
  };

  const handlePageInfoSet = useCallback((info: PageInfoType) => {
    setPageInfo(info);
  }, []);

  return (
    <Section>
      <Box
        flex
        justifyContent="between"
        className="mb-4 sm:flex-row flex-col gap-2"
      >
        <Tabs
          defaultValue={TimeLineView.UPCOMING}
          onValueChange={handleTabChange}
        >
          <TabList>
            <Tab value={TimeLineView.UPCOMING}>Upcoming</Tab>
            <Tab value={TimeLineView.COMPLETED}>Completed</Tab>
            <Tab value={TimeLineView.ALL}>All Webinar</Tab>
          </TabList>
        </Tabs>
        <Box>
          <SearchBox />
        </Box>
      </Box>
      {/* webinars list */}
      <Suspense fallback={<WebinarsLoader />}>
        <Webinars
          timeLineView={timeLineView}
          page={page}
          setPageInfo={handlePageInfoSet}
        />
      </Suspense>

      <Pagination
        itemsPerPage={pageInfo.perPage}
        count={pageInfo.total}
        page={pageInfo.currentPage}
        onPageChange={setPage}
      />
    </Section>
  );
};

export default UpcomingAndCompletedWebinars;
